import { parseSceneConfig, startGame } from '../render/game'

// Vite entrypoint: boot the render adapter over the sim core, drawing from a
// between-tick snapshot, and show a live FPS + scene readout. Colonist and
// chain-group counts are swept via ?colonists= and ?groups= query params.

function boot(): void {
  const canvas = document.getElementById('game') as HTMLCanvasElement | null
  const fpsEl = document.getElementById('fps')
  if (!canvas) {
    console.error('autocol: #game canvas not found')
    return
  }

  const config = parseSceneConfig(window.location.search)
  const game = startGame('game', config)

  if (fpsEl) {
    window.setInterval(() => {
      const fps = Math.round(game.fps())
      const view = game.view()
      const carrying = view.units.filter((u) => u.cargo !== null).length
      fpsEl.textContent =
        `${fps} fps · tick ${view.tick} · ` +
        `${config.colonistCount} colonists × ${config.groupCount} chain(s) · ` +
        `${carrying} hauling`
    }, 250)
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot)
} else {
  boot()
}
